<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Room'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-card>
      <form [formGroup]="form">
        <tidy-row class="field-top-padding field-bottom-padding">
          <tidy-auto-complete
            [label]="'Room'"
            formControlName="name"
            [options]="rooms"
            [form]="form.controls.name"
            [icon]="'assets/svg/information-circle.svg'"
            [isToSearchBetweenOptions]="true"
            [submitted]="submitted"
            [errorMessage]="'Please enter the name of the room.'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-select
            [icon]="'assets/svg/home.svg'"
            [label]="'Floor'"
            [form]="form.controls.floor"
            formControlName="floor"
            [items]="floorSelectItems" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [icon]="'assets/svg/ellipsis-horizontal-circle.svg'"
            [label]="'Room Type'"
            [form]="form.controls.category"
            formControlName="category"
            [items]="roomTypeSelectItems" />
        </tidy-row>
      </form>
    </tidy-card>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-button
      [text]="'Add Room'"
      [action]="boundAddRoom"
      class="primary" />

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
